import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* REST API */
import { list, read } from "../../api/Notification"

/* Widgets */
import { Layout } from "../Table"

/* Components */
import { Pagination } from "../../components"

/* Icons */
import { CloseIcon, BellIcon, PauseIcon, InboxIcon, CheckAllIcon, ArrowUpRightIcon } from "../../components/Icons"
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* THE STATE OF A CLOSED PANEL — open() STARTS FROM IT EVERY TIME */
const EMPTY = {
    status: "loading",
    data: [],
    count: 0,
    unread: 0,
    page: 1,
    waiting: false,
}

/* THE SIZE OF A PAGE — THE VERY SAME NUMBER THE CONTROLLER KEEPS */
const LIMIT = 10


/* Widget Notifications */
class Notifications extends Component {

    constructor() {
        super()

        this.state = { visible: false, ...EMPTY }
    }

    /* Open */
    open = () => {

        /* Open Modal */
        this.setState({ visible: true, ...EMPTY })

        /* Load Action */
        this.load()
    }

    /* Close — the rows are dropped after the closing transition, not in the middle of it */
    close = () => this.setState({ visible: false })


    /* Load Action */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { onUpdate } = this.props

        /* Set Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading", data: [] })
        }

        /* Load Notifications */
        list(page).then((response) => {
            if (response.status === 200) {

                this.setState({
                    status: "ok",
                    data: utils.checkValue(response.data.list, []),
                    count: parseInt(utils.checkValue(response.data.count, 0)),
                    unread: parseInt(utils.checkValue(response.data.unread, 0)),
                })

                /* Update The Badge — the shown page has just turned read */
                if (onUpdate) {
                    onUpdate()
                }

            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0, unread: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0, unread: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0, unread: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0, unread: 0 })
        })
    }


    /* Read Everything */
    readAll = () => {

        /* Fields */
        const { waiting, unread } = this.state
        const { onUpdate } = this.props

        /* Check Waiting */
        if (waiting || unread === 0) {
            return
        }

        /* Start Reading */
        this.setState({ waiting: true })

        /* Read Notifications */
        read().then((response) => {
            if (response.status === 200) {

                /* Every Row Turns Read */
                this.setState((state) => ({ unread: 0, data: state.data.map((item) => ({ ...item, seen: true })) }))

                /* Update The Badge */
                if (onUpdate) {
                    onUpdate()
                }

            }
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }


    /* Go To The Table */
    go = (item) => {

        /* Fields */
        const { navigate } = this.props

        /* Check Table */
        if (!item.game || !item.uid) {
            return
        }

        /* Close Panel */
        this.close()

        /* Open Table */
        if (navigate) {
            navigate(`/table/${item.game}/${item.uid}`)
        }
    }


    /* TITLE OF A GAME — THE KEY OF THE TABLE IS THE ONLY SOURCE, THE NAME COMES FROM THE CATALOGUE */
    title = (key) => {

        /* Fields */
        const { catalog } = this.props
        const game = catalog.games.find((item) => item.key === key)

        /* Send Result */
        return game ? game.name : utils.checkValue(key, "—")
    }


    /* Draw Element */
    _element = (item, index) => {

        /* Fields */
        const paused = item.type === "pause"
        const place = [this.title(item.game), item.studio].filter((value) => value).join(" · ")

        return (
            <div onClick={() => this.go(item)} className={`notification--item ${item.seen ? "" : "fresh"}`} key={`${index}`}>

                <div className={`notification--item-icon ${paused ? "pause" : ""}`}>
                    {paused ? <PauseIcon size={16} /> : <BellIcon size={17} />}
                </div>

                <div className="notification--item-text">

                    <div className="notification--item-top">
                        <span className="notification--item-name">{utils.checkValue(item.name, "—")}</span>
                        {!item.seen && <span className="notification--item-tag">{t("notification.new")}</span>}
                    </div>

                    <div className="notification--item-message">{utils.checkValue(item.message, "—")}</div>

                    {place !== "" && <div className="notification--item-place">{place}</div>}

                </div>

                <div className="notification--item-side">

                    <div className="notification--item-date">
                        <b>{moment(item.createdAt).format("HH:mm")}</b>
                        <span>{moment(item.createdAt).format("D MMM")}</span>
                    </div>

                    <div className="notification--item-go" title={t("notification.go")}>
                        <ArrowUpRightIcon size={13} />
                    </div>

                </div>

            </div>
        )
    }


    /* Draw Read Button */
    _read = () => {

        /* Fields */
        const { status, unread, waiting } = this.state

        /* Check Rows */
        if (status !== "ok" || unread === 0) {
            return null
        }

        return (
            <div onClick={() => this.readAll()} className={`notification--read ${waiting ? "loading" : ""}`} title={t("notification.readAll")}>
                {waiting ? <LoadingOutlined /> : <CheckAllIcon size={15} />}
                <span>{t("notification.readAll")}</span>
            </div>
        )
    }


    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status, data, page, count } = this.state

        /* Layout */
        if (status !== "ok") {
            return (
                <div className="profile--layout">
                    <Layout status={status} reload={() => this.load(1, true)} />
                </div>
            )
        }

        /* Empty */
        if (data.length === 0) {
            return (
                <div className="profile--layout">
                    <div className="profile--empty">
                        <InboxIcon size={36} />
                        <p>{t("notification.empty")}</p>
                    </div>
                </div>
            )
        }

        return (
            <div className="profile--body list">

                <div className="notification--list">
                    {data.map((item, index) => this._element(item, index))}
                </div>

                {count > LIMIT && <Pagination size={LIMIT} page={page} total={count} onPageChange={(value) => this.load(value)} />}

            </div>
        )
    }


    render = () => {

        /* Fields */
        const { visible, status, count, unread } = this.state

        /* Fields */
        const subtitle = unread > 0
            ? `${unread} ${t("notification.unread")}`
            : status === "ok" && count > 0 ? `${count} ${t("notification.records")}` : t("notification.subtitle")

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                onAfterClose={() => this.setState({ ...EMPTY })}
                className="profile--modal wide notification--modal"
                overlayClassName="profile--overlay"
                closeTimeoutMS={220}
            >

                <div className="profile--header">

                    <div className={`profile--header-icon ${unread > 0 ? "fresh" : ""}`}><BellIcon size={17} /></div>

                    <div className="profile--header-text">
                        <h2>{t("notification.title")}</h2>
                        <span>{subtitle}</span>
                    </div>

                    {/* Draw Read Button */}
                    {this._read()}

                    <div onClick={() => this.close()} className="profile--close">
                        <CloseIcon size={13} />
                    </div>

                </div>

                {/* Draw Body */}
                {this._body()}

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    catalog: state.catalog,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Notifications)
